webpackJsonp([80],{

/***/ 1616:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(816);


/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(98);

var _datetime2 = _interopRequireDefault(_datetime);

var _de = __webpack_require__(562);

var _de2 = _interopRequireDefault(_de);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('de', _de2.default);

/***/ })

},[1616]);


// WEBPACK FOOTER //
// app/datetime.de-4fef4e42cf432e9543d4.js